import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { Button, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { IconButtonWithTooltip } from 'shared-components';
import { useTranslation } from "react-i18next";

interface IProps {
  callbackOnSelect?: (option: boolean) => void; // used to refresh global state if needed.
}

/**
 * Generalised message filter toolbar component that works with the admissions and cas workflow dashboards.
 * Does not interface with global state, just updates the window QSPs.
 */
export const MessageFilter = ({ callbackOnSelect = () => {} }: IProps) => {
    const { t } = useTranslation('common');
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);

  const isMessageOpened = params.get('unread_messages') === 'true';

  const toggleMessageFilter = () => {
    try {
      params.set('page', '1');
      if (isMessageOpened) {
        params.delete('unread_messages');
      } else {
        params.set('unread_messages', 'true');
      }
      navigate({ search: params.toString() });
    } catch (error) {
      // If navigation fails, still call the callback but don't crash
      console.warn('Navigation failed:', error);
    }

    // Only call callback if it's a function
    if (typeof callbackOnSelect === 'function') {
      callbackOnSelect(isMessageOpened);
    }
  };

  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <IconButtonWithTooltip
        label={t('common:toggleUnreadMessages')}
        iconProps={{ icon: faEnvelope }}
        buttonProps={{ size: 'md', variant: 'ghost', isActive: isMessageOpened }}
        onClick={toggleMessageFilter}
      />
    );
  }

  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        flexShrink="0"
        onClick={toggleMessageFilter}
        isActive={isMessageOpened}
        leftIcon={<FontAwesomeIcon className="utility-icon" icon={faEnvelope} />}
      >
        {t('common:unread')}
                    </Button>
    </>
  );
};
